module.exports = __webpack_public_path__ + "static/img/b5.5ec7d4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/tutorial2/b5.jpg
// module id = ZVY5
// module chunks = 14